import { useMemo, type ReactNode } from 'react';
import {
  groupByAdvertisingRegion,
  type AdvertisingAccountRegion,
} from '@/api/advertisingAccountRegions';

function RegionHeading({ code, label }: { code: string; label: string }) {
  return (
    <h3 className="flex items-center px-1 text-body-md font-medium text-brand-ink">
      <span className="inline-block w-8 shrink-0 leading-none">{code}</span>
      <span className="min-w-0 leading-none">{label}</span>
    </h3>
  );
}

export function AdvertisingAccountRegionGroups<T>({
  items,
  resolveRegion,
  renderItem,
  getItemKey,
}: {
  items: T[];
  resolveRegion: (item: T) => AdvertisingAccountRegion;
  renderItem: (item: T, index: number) => ReactNode;
  getItemKey: (item: T, index: number) => string;
}) {
  const groups = useMemo(
    () => groupByAdvertisingRegion(items, resolveRegion),
    [items, resolveRegion]
  );

  return (
    <div className="space-y-4">
      {groups.map((group) => (
        <section key={group.id} className="space-y-2">
          <RegionHeading code={group.id} label={group.label} />
          <ul className="space-y-2">
            {group.items.map((item, index) => (
              <li key={getItemKey(item, index)}>{renderItem(item, index)}</li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
